import { isBrowser } from '@/utils/environment';

export interface IScrollIntoViewOptions {
  /**
   * offset-y in px
   */
  offset?: number;
  /**
   * Container element that has scroll
   */
  container?: HTMLElement;
}

/**
 * Same as Javascript scrollIntoView() but with custom offset and container. Only vertical scroll.
 * @param element Element to scroll into view
 * @param options.offset Additional offset-y in px to scroll, default 0
 * @param options.container Custom scroll container, default html tag
 */
export const scrollIntoView = (element: HTMLElement, options?: IScrollIntoViewOptions): void => {
  if (!isBrowser()) return;

  const container = options?.container || document.documentElement;
  const offset = options?.offset || 0;

  // NOTE: this will only work if element and container have common offsetParent (element with position !== static)
  const offsetPosition = element.offsetTop - container.offsetTop + offset;

  container.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
};
